import React from 'react';

import {
  Colors,
  CommonTheme,
  FontSizePropKey,
  useCurrentTheme,
} from 'app/shared/theme';
import { Box, Typography } from 'app/shared/components/atoms';

interface StatusBarProps {
  statusMessage?: string;
  messageType?: keyof Colors['messaging'];
  fontSize?: FontSizePropKey;
  lineHeight?: string;
  borderRadiusBottomLeft?: string;
  borderRadiusBottomRight?: string;
  'data-qaid'?: string;
}

export const StatusBar = ({
  statusMessage,
  messageType,
  fontSize,
  lineHeight,
  borderRadiusBottomLeft,
  borderRadiusBottomRight,
  'data-qaid': qaId,
}: StatusBarProps) => {
  const { colors } = useCurrentTheme() as CommonTheme;

  if (!statusMessage || !messageType) {
    return null;
  }

  return (
    <Box
      backgroundColor={colors.messaging[messageType].light}
      justifyContent="center"
      alignItems="center"
      py={2}
      px={4}
      h="fit-content"
      w="100%"
      data-qaid={qaId}
      borderRadiusBottomLeft={borderRadiusBottomLeft}
      borderRadiusBottomRight={borderRadiusBottomRight}
    >
      <Typography
        fontWeight="semibold"
        textTransform="uppercase"
        color={colors.messaging[messageType].dark}
        fontSize={fontSize}
        lineHeight={lineHeight}
      >
        {statusMessage}
      </Typography>
    </Box>
  );
};
